/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Verb_Task_ReassignedInputs */

const en_case_history_verb_task_reassigned = /** @type {(inputs: Case_History_Verb_Task_ReassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`re-assigned to`)
};

const pt_br2_case_history_verb_task_reassigned = /** @type {(inputs: Case_History_Verb_Task_ReassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reatribuída para`)
};

/**
* | output |
* | --- |
* | "re-assigned to" |
*
* @param {Case_History_Verb_Task_ReassignedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_verb_task_reassigned = /** @type {((inputs?: Case_History_Verb_Task_ReassignedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Verb_Task_ReassignedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_verb_task_reassigned(inputs)
	return pt_br2_case_history_verb_task_reassigned(inputs)
});